export var DEPARTMENT;
(function (DEPARTMENT) {
    DEPARTMENT["\uACBD\uC601\uC9C4"] = "\uACBD\uC601\uC9C4";
    DEPARTMENT["\uAE30\uD68D\uAD00\uB9AC\uBD80"] = "\uAE30\uD68D\uAD00\uB9AC\uBD80";
    DEPARTMENT["\uC5F0\uAD6C\uAE30\uD68D\uBD80"] = "\uC5F0\uAD6C\uAE30\uD68D\uBD80";
    DEPARTMENT["\uAE30\uC220\uC0AC\uC5C5\uBD80"] = "\uAE30\uC220\uC0AC\uC5C5\uBD80";
    DEPARTMENT["\uC0DD\uC0B0\uAE30\uC220\uBD80"] = "\uC0DD\uC0B0\uAE30\uC220\uBD80";
})(DEPARTMENT || (DEPARTMENT = {}));
export var POSITION;
(function (POSITION) {
    POSITION["\uB9E4\uB2C8\uC800"] = "\uB9E4\uB2C8\uC800";
    POSITION["\uB300\uD45C\uC774\uC0AC"] = "\uB300\uD45C\uC774\uC0AC";
    POSITION["\uD68C\uC7A5"] = "\uD68C\uC7A5";
    POSITION["\uBD80\uD68C\uC7A5"] = "\uBD80\uD68C\uC7A5";
    POSITION["\uC0AC\uC7A5"] = "\uC0AC\uC7A5";
    POSITION["\uBD80\uC0AC\uC7A5"] = "\uBD80\uC0AC\uC7A5";
    POSITION["\uC804\uBB34"] = "\uC804\uBB34";
    POSITION["\uC0C1\uBB34"] = "\uC0C1\uBB34";
    POSITION["\uC774\uC0AC"] = "\uC774\uC0AC";
    POSITION["\uC0C1\uC784\uACE0\uBB38"] = "\uC0C1\uC784\uACE0\uBB38";
    POSITION["\uACE0\uBB38"] = "\uACE0\uBB38";
    POSITION["\uD300\uC7A5"] = "\uD300\uC7A5";
    POSITION["\uBD80\uC7A5"] = "\uBD80\uC7A5";
    POSITION["\uC218\uC11D"] = "\uC218\uC11D";
    POSITION["\uCC28\uC7A5"] = "\uCC28\uC7A5";
    POSITION["\uC2E4\uC7A5"] = "\uC2E4\uC7A5";
    POSITION["\uCC45\uC784"] = "\uCC45\uC784";
    POSITION["\uACFC\uC7A5"] = "\uACFC\uC7A5";
    POSITION["\uC120\uC784"] = "\uC120\uC784";
    POSITION["\uB300\uB9AC"] = "\uB300\uB9AC";
    POSITION["\uC8FC\uC784"] = "\uC8FC\uC784";
    POSITION["\uC0AC\uC6D0"] = "\uC0AC\uC6D0";
})(POSITION || (POSITION = {}));
export var GROUP_ID;
(function (GROUP_ID) {
    GROUP_ID["\uAD00\uB9AC\uC790"] = "1";
    GROUP_ID["\uC790\uC7AC\uAE08\uC561\uB178\uCD9C"] = "2";
    GROUP_ID["\uC6D0\uAC00\uAD00\uB9AC"] = "3";
    GROUP_ID["\uC601\uC5C5\uAD00\uB9AC"] = "4";
    GROUP_ID["\uAD6C\uB9E4\uAD00\uB9AC"] = "12";
    GROUP_ID["B_Data"] = "14";
    GROUP_ID["\uAE30\uBCF8"] = "15";
    GROUP_ID["\uC7AC\uACE0\uC870\uD68C"] = "16";
    GROUP_ID["\uC785\uACE0\uC2E0\uCCAD"] = "17";
    GROUP_ID["\uCD9C\uACE0\uC2E0\uCCAD"] = "18";
})(GROUP_ID || (GROUP_ID = {}));
